module.exports = __webpack_public_path__ + "static/media/ZEPICK.c4750b83.svg";